export class ShowValidation {
  static readonly type = '[Transaction] Show Validation';
  constructor() {}
}

export class ShowError {
  static readonly type = '[Transaction] Show Payment Error';
  constructor(public payload: any) {}
}

export class SetTransaction {
  static readonly type = '[Transaction] Set Transaction';
  constructor(public payload: any) {}
}
